import { FactList } from "@/shared/components/FactList";
import { type TriggerRecord } from "@/shared/domain/triggers";

/** The identity and audit facts of a trigger, as a two-column list. */
export function TriggerFacts({ record }: { record: TriggerRecord }) {
  return (
    <FactList>
      <FactList.Item label="Name">{record.name}</FactList.Item>
      <FactList.Item label="Trigger ID" mono>
        {record.trigger_id}
      </FactList.Item>
      <FactList.Item label="Created by">{record.created_by}</FactList.Item>
      <FactList.Item label="Last modified by">
        {record.modified_by}
      </FactList.Item>
    </FactList>
  );
}
